import React from 'react';
import Button from './Button';
import StellineRewardChip from './StellineRewardChip';
import styles from '../styles/Ortografia.module.css';
import modalStyles from '../styles/modal.module.css';

export const DIFFICULTY_OPTIONS = [
  {
    name: 'A1',
    value: 'A1',
    title: 'A1 - elementare',
  },
  {
    name: 'A2',
    value: 'A2',
    title: 'A2 - pre-intermedio',
  },
  {
    name: 'B1',
    value: 'B1',
    title: 'B1 - intermedio',
  },
  {
    name: 'B2',
    value: 'B2',
    title: 'B2 - intermedio-avanzato',
  },
  {
    name: 'C1',
    value: 'C1',
    title: 'C1 - avanzato',
  },
  {
    name: 'C2',
    value: 'C2',
    title: 'C2 - padronanza',
  },
];

export const DifficultySelectionContent = ({
  pendingDifficulty,
  onDifficultyChange,
  onConfirm,
  isEventPending,
  getDifficultyReward,
}) => {
  return (
    <div className={`${modalStyles.modalContent} ${styles.difficultyModalContent}`}>
      <p className={styles.difficultyModalText}>Prima dell'inizio della partita, seleziona il tuo livello linguistico:</p>
      <div className={styles.difficultySelection}>
        <ul>
          {DIFFICULTY_OPTIONS.map((option, index) => {
            const rewardAmount = typeof getDifficultyReward === 'function'
              ? Number(getDifficultyReward(option.value))
              : NaN;
            const hasRewardAmount = Number.isFinite(rewardAmount) && rewardAmount > 0;

            return (
              <li key={index}>
                <input
                  type="radio"
                  name="difficultyGroup"
                  id={`difficulty-${option.name}`}
                  value={option.value}
                  checked={option.value === pendingDifficulty}
                  onChange={() => onDifficultyChange(option.value)}
                />
                <label htmlFor={`difficulty-${option.name}`}>
                  <span>{option.title}</span>
                  {hasRewardAmount && (
                    <StellineRewardChip
                      amount={rewardAmount}
                      compact
                      className={styles.difficultyReward}
                    />
                  )}
                </label>
              </li>
            );
          })}
        </ul>
      </div>
      <div className={styles.difficultyModalActions}>
        <Button primary onClick={onConfirm} disabled={isEventPending} loading={isEventPending}>
          Comincia
        </Button>
      </div>
    </div>
  );
};

export default DifficultySelectionContent;
